import { Device, State } from '../../types'

export const getDeviceById = (state: State, id: string): Device | undefined => {
  return state.DeviceById[id]
}
